module.exports = __webpack_public_path__ + "static/media/1004848.4c0e1e63.png";